import { useEffect, useState } from "react";

const Frame1 = () => {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.5 8.125V16.25M32.5 56.8751V48.7501M11.3906 44.6876L18.4271 40.6251M56.875 32.5001H48.75M44.6875 53.6093L40.625 46.5728M8.125 32.5001H16.25M20.3125 11.3906L24.375 18.4271M20.3125 53.6093L24.375 46.5728M53.6093 44.6876L46.573 40.6251M11.3906 20.3125L18.4271 24.375"
        stroke="#9CD3D3"
        strokeOpacity="0.5"
        strokeWidth="2.91667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Frame2 = () => {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.875 32.5H48.75M8.12494 32.5H16.2499M20.3124 11.3906L24.3749 18.4271M32.4999 56.875V48.75M11.3907 44.6875L18.4272 40.625M32.4999 8.125V16.25M53.6094 20.3125L46.5729 24.375M11.3907 20.3125L18.4272 24.375M20.3124 53.6093L24.3749 46.573M44.6875 11.3906L40.625 18.4271"
        stroke="#9CD3D3"
        strokeOpacity="0.5"
        strokeWidth="2.91667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Frame3 = () => {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.5 56.875V48.75M32.5 8.12494V16.2499M53.6094 20.3124L46.5729 24.3749M8.125 32.4999H16.25M20.3125 11.3907L24.375 18.4272M56.875 32.4999H48.75M44.6875 53.6094L40.625 46.5729M44.6875 11.3907L40.625 18.4272M11.3907 20.3124L18.427 24.3749M53.6094 44.6875L46.5729 40.625"
        stroke="#9CD3D3"
        strokeOpacity="0.5"
        strokeWidth="2.91667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Frame4 = () => {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.125 32.5H16.25M56.8751 32.5H48.7501M44.6876 53.6094L40.6251 46.5729M32.5001 8.125V16.25M53.6093 20.3125L46.5728 24.375M32.5001 56.875V48.75M11.3906 44.6875L18.4271 40.625M53.6093 44.6875L46.5728 40.625M44.6876 11.3907L40.6251 18.427M20.3125 53.6094L24.375 46.5729"
        stroke="#9CD3D3"
        strokeOpacity="0.5"
        strokeWidth="2.91667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const frames = [Frame1, Frame2, Frame3, Frame4];

const LoadingSpinner = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % frames.length);
    }, 120); // 120ms per frame
    return () => clearInterval(interval);
  }, []);

  const CurrentFrame = frames[index];
  return <CurrentFrame />;
};

export default LoadingSpinner;
